// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TuFx","textarea":"styles_textarea__3ISmX"};